import { useDispatch, useSelector } from "react-redux";
import AdminHeader from "../components/AdminHeader";
import Footer from "../components/Footer";
import Loading from "../components/Loading";
import { requestLogout } from "../../../redux/slices/authSlice";

function AdminLayout({ children }) {
  const { loading } = useSelector((state) => state.adminState);
  const dispatch = useDispatch();

  async function handleLogout() {
    dispatch(requestLogout());
  }

  return (
    <div className="flex-col flex positive">
      {loading && <Loading />}

      <div className="w-100 bg-main h-[54px] flex items-center justify-end px-32">
        <span
          className="font-semibold text-white cursor-pointer hover:text-main hover:bg-white py-4 px-8"
          onClick={handleLogout}
        >
          Đăng xuất
        </span>
      </div>
      <div className="grid grid-cols-12 items-center justify-center">
        <div className="col-span-1"></div>
        <div className="col-span-10">
          <AdminHeader />
        </div>
        <div className="col-span-1"></div>
      </div>

      <div className="grid grid-cols-12">
        <div className="col-span-1" />
        <div className="col-span-10">
          <div className="py-8 h-[calc(100%_-_400px)]">{children}</div>
        </div>
        <div className="col-span-1" />
      </div>
      <Footer />
    </div>
  );
}

export default AdminLayout;
